import mock from '../mock'

const data = {
  tasks: [
    {
      id: 1,
      title: 'Cập nhật và phân tích dữ liệu tỷ lệ tăng dân số tháng 12',
      dueDate: '2020-11-25',
      description:
        'Tổng hợp dữ liệu tỷ lệ sinh, tỷ lệ tử và tỷ lệ nhập cư trong tháng. Phân tích mật độ dân số theo từng khu vực phường và dự báo dân số 5 năm tới. Báo cáo kết quả lên ban lãnh đạo IOC.',
      assignee: {
        fullName: 'Jacob Ramirez',
        avatar: require('@src/assets/images/avatars/12.png').default
      },
      tags: ['update'],
      isCompleted: false,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 2,
      title: 'Rà soát danh sách doanh nghiệp thành lập mới và ngừng hoạt động trong quý 4',
      dueDate: '2020-12-14',
      description:
        'Cập nhật số doanh nghiệp thành lập mới, doanh nghiệp ngừng hoạt động và tính tỷ lệ doanh nghiệp nhỏ và vừa. Tổng hợp doanh thu ngành thương mại, dịch vụ, sản xuất và đối chiếu với mục tiêu kinh tế địa phương theo quý.',
      assignee: {
        fullName: 'Andrew Anderson',
        avatar: ''
      },
      tags: ['team', 'medium'],
      isCompleted: true,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 3,
      title: 'Kiểm tra và đối chiếu dự toán thu chi ngân sách quý',
      dueDate: '2020-11-25',
      description:
        'Kiểm tra thực thu thực chi so với dự toán, tính tỷ lệ thu vượt/chậm thu và rà soát số hồ sơ thanh toán trễ hạn. Lập báo cáo cân đối ngân sách và dự báo ngân sách cho quý tiếp theo gửi ban lãnh đạo.',
      assignee: {
        fullName: 'Benjamin Jacobs',
        avatar: ''
      },
      tags: ['high'],
      isCompleted: false,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 4,
      title: 'Phân tích số liệu tai nạn giao thông và đề xuất biện pháp can thiệp',
      dueDate: '2020-11-20',
      description:
        'Tổng hợp số vụ tai nạn giao thông, số người thương vong và số vi phạm vượt đèn đỏ, quá tốc độ. Phân tích tỷ lệ ùn tắc theo giờ, mật độ phương tiện và chỉ số an toàn giao thông. Đề xuất biện pháp điều tiết giao thông tại các điểm nóng.',
      assignee: {
        fullName: 'Curtis Schmidt',
        avatar: require('@src/assets/images/avatars/9.png').default
      },
      tags: ['medium'],
      isCompleted: false,
      isDeleted: false,
      isImportant: true
    },
    {
      id: 5,
      title: 'Giám sát chỉ số chất lượng không khí (AQI) và cảnh báo điểm ô nhiễm',
      dueDate: '2020-12-06',
      description:
        'Thu thập dữ liệu chỉ số AQI, mức PM2.5, PM10 và NO2 từ các điểm cảm biến IoT. Xác định số điểm ô nhiễm nghiêm trọng và số điểm nóng sinh thái cần ưu tiên xử lý. Gửi cảnh báo và đề xuất biện pháp xử lý vi phạm môi trường kịp thời.',
      assignee: {
        fullName: 'Katherine Perkins',
        avatar: require('@src/assets/images/avatars/9.png').default
      },
      tags: ['medium'],
      isCompleted: true,
      isDeleted: false,
      isImportant: true
    },
    {
      id: 6,
      title: 'Theo dõi và cập nhật số liệu camera an ninh tại các điểm nóng',
      dueDate: '2020-12-06',
      description:
        'Kiểm tra tỷ lệ camera an ninh đang hoạt động và xử lý các camera lỗi trên toàn địa bàn. Tổng hợp số vụ phạm pháp, số vụ nghiêm trọng và số phản ánh an ninh từ người dân. Cập nhật bản đồ điểm nóng an ninh trên hệ thống IOC.',
      assignee: {
        fullName: 'David Murphy',
        avatar: ''
      },
      tags: ['high', 'medium'],
      isCompleted: true,
      isDeleted: true,
      isImportant: false
    },
    {
      id: 7,
      title: 'Cập nhật tỷ lệ tiêm chủng và số ca bệnh truyền nhiễm mới',
      dueDate: '2020-12-05',
      description:
        'Cập nhật số ca bệnh mới theo ngày, số ca nghiêm trọng và tỷ lệ tiêm chủng trên địa bàn. Theo dõi tỷ lệ ca bệnh truyền nhiễm và lập kế hoạch ứng phó dịch kịp thời. Ghi nhận mức hài lòng dịch vụ y tế và chi phí y tế trung bình trên đầu người.',
      assignee: {
        fullName: 'Karina Miller',
        avatar: require('@src/assets/images/avatars/1.png').default
      },
      tags: ['medium'],
      isCompleted: false,
      isDeleted: false,
      isImportant: true
    },
    {
      id: 8,
      title: 'Tổng hợp số liệu tỷ lệ bỏ học và điểm trung bình học sinh',
      dueDate: '2020-12-08',
      description:
        'Tổng hợp số học sinh, tỷ lệ đi học và tỷ lệ bỏ học theo từng trường trên địa bàn phường. Tính điểm trung bình học sinh, tỷ lệ học sinh đạt chuẩn và phân bổ học lực. Lập danh sách học sinh cần hỗ trợ học tăng cường và ngoại khóa.',
      assignee: {
        fullName: 'Thomas Moses',
        avatar: require('@src/assets/images/avatars/7.png').default
      },
      tags: ['low', 'medium'],
      isCompleted: false,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 9,
      title: 'Xử lý tồn đọng hồ sơ dịch vụ công quá hạn',
      dueDate: '2020-11-25',
      description:
        'Rà soát hồ sơ tiếp nhận, hồ sơ tồn đọng quá hạn và tỷ lệ hồ sơ bị trả lại theo từng loại thủ tục hành chính. Phân tích thời gian trung bình xử lý và triển khai cải tiến quy trình để nâng cao tỷ lệ giải quyết đúng hạn và tỷ lệ dịch vụ trực tuyến.',
      assignee: {
        fullName: 'Angel Morrow',
        avatar: ''
      },
      tags: ['high', 'update'],
      isCompleted: false,
      isDeleted: true,
      isImportant: false
    },
    {
      id: 10,
      title: 'Kiểm tra và lập kế hoạch sửa chữa các điểm hư hỏng hạ tầng đô thị',
      dueDate: '2020-12-09',
      description:
        'Kiểm tra số vụ hư hỏng hạ tầng mới phát sinh, thời gian xử lý và số cống tắc trên địa bàn. Rà soát tỷ lệ đèn đường hoạt động, số cây xanh hư hỏng và số báo cáo hạ tầng từ người dân. Lập kế hoạch bảo trì định kỳ và ưu tiên đầu tư hạ tầng thông minh mới.',
      assignee: {
        fullName: 'Karen Carrillo',
        avatar: ''
      },
      tags: ['low'],
      isCompleted: true,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 11,
      title: 'Rà soát hồ sơ đất đai tồn đọng và số tranh chấp chưa giải quyết',
      dueDate: '2020-12-01',
      description:
        'Rà soát danh sách hồ sơ đất đai tồn đọng, số tranh chấp đất dân sự và diện tích đất bị tranh chấp chưa giải quyết. Kiểm tra số hành vi vi phạm đất đai, số quyết định xử phạt và tiến độ cập nhật bản đồ GIS trên hệ thống IOC.',
      assignee: {
        fullName: 'Timothy Brewer',
        avatar: require('@src/assets/images/avatars/1.png').default
      },
      tags: ['low'],
      isCompleted: true,
      isDeleted: false,
      isImportant: true
    },
    {
      id: 12,
      title: 'Theo dõi tiến độ các dự án quy hoạch đô thị đang triển khai',
      dueDate: '2020-12-09',
      description:
        'Cập nhật tiến độ các dự án đang triển khai, danh sách dự án bị chậm tiến độ và tỷ lệ phù hợp quy hoạch. Tổng hợp số giấy phép xây dựng cấp mới, số hành vi xây dựng không phép và mức độ hài lòng của dân cư với công tác quy hoạch đô thị.',
      assignee: {
        fullName: 'Brian Barry',
        avatar: ''
      },
      tags: ['team'],
      isCompleted: false,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 13,
      title: 'Kiểm tra tỷ lệ hoạt động và xử lý sự cố thiết bị IoT toàn hệ thống',
      dueDate: '2020-12-01',
      description:
        'Kiểm tra tổng số thiết bị IoT, tỷ lệ hoạt động và số thiết bị báo lỗi cần xử lý. Xử lý kịp thời các sự cố camera giám sát, cảm biến môi trường và cảm biến giao thông. Đánh giá chi phí bảo trì và tỷ lệ thiết bị kết nối 5G trên toàn hệ thống.',
      assignee: {
        fullName: 'Joshua Golden',
        avatar: require('@src/assets/images/avatars/5.png').default
      },
      tags: ['team'],
      isCompleted: false,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 14,
      title: 'Cấu hình và kiểm thử hệ thống AI dự báo cảnh báo sớm',
      dueDate: '2020-11-29',
      description:
        'Cấu hình mô hình AI dự báo ùn tắc, tai nạn, tình trạng ô nhiễm và dịch bệnh. Kiểm tra tỷ lệ cảnh báo chính xác, tỷ lệ cảnh báo sai và tối ưu hóa thuật toán dự báo. Đánh giá kết quả dự báo di cư, kinh tế và nhu cầu y tế theo thời gian thực.',
      assignee: {
        fullName: 'Paula Hammond',
        avatar: require('@src/assets/images/avatars/5.png').default
      },
      tags: ['medium'],
      isCompleted: true,
      isDeleted: false,
      isImportant: true
    },
    {
      id: 15,
      title: 'Nâng cấp tỷ lệ xác thực Digital ID và hệ thống e-Gov',
      dueDate: '2020-11-29',
      description:
        'Nâng cao tỷ lệ xác thực Digital ID và triển khai e-Ký số cho các dịch vụ công trực tuyến. Theo dõi tỷ lệ thanh toán điện tử, tỷ lệ sử dụng chatbot và số lỗi hệ thống phát sinh. Đảm bảo uptime hệ thống và xử lý kịp thời các sự cố an ninh mạng.',
      assignee: {
        fullName: 'Tyler Garcia',
        avatar: ''
      },
      tags: ['medium'],
      isCompleted: false,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 16,
      title: 'Kiểm tra điểm vi phạm an toàn thực phẩm tại chợ và siêu thị',
      dueDate: '2020-12-12',
      description:
        'Lập danh sách điểm kiểm tra an toàn thực phẩm tại chợ truyền thống và siêu thị trên địa bàn. Ghi nhận tỷ lệ vi phạm, số cảnh báo thực phẩm không an toàn và thời gian xử lý. Xử lý nhanh các trường hợp vi phạm và công bố chỉ số an toàn thực phẩm định kỳ.',
      assignee: {
        fullName: 'Darlene Shields',
        avatar: require('@src/assets/images/avatars/1.png').default
      },
      tags: ['low'],
      isCompleted: true,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 17,
      title: 'Xử lý danh sách xe hết hạn đăng kiểm và thông báo đến chủ xe',
      dueDate: '2020-12-04',
      description:
        'Tra cứu và gửi thông báo đến chủ xe hết hạn đăng kiểm trong 30 ngày tới. Kiểm tra tỷ lệ xe đạt và không đạt kiểm định, số xe vi phạm khí thải và chỉ số khí thải trung bình. Theo dõi tỷ lệ sử dụng công suất tại các trung tâm đăng kiểm và cảnh báo nguy cơ quá tải.',
      assignee: {
        fullName: 'Destiny Michael',
        avatar: ''
      },
      tags: ['medium', 'low'],
      isCompleted: false,
      isDeleted: false,
      isImportant: false
    },
    {
      id: 18,
      title: 'Tổng kết KPI năm và xây dựng mục tiêu kế hoạch năm tiếp theo',
      dueDate: '2020-11-18',
      description:
        'Tổng kết các chỉ số KPI năm gồm chỉ số phát triển bền vững, tỷ lệ hoàn thành kế hoạch năm, chỉ số minh bạch và tốc độ chuyển đổi số. Phân tích mục tiêu kinh tế, môi trường và xã hội đã đạt được. Đề xuất kế hoạch năm tiếp theo với tỷ lệ cải tiến liên tục.',
      assignee: {
        fullName: 'Danielle Anderson',
        avatar: require('@src/assets/images/portrait/small/avatar-s-9.jpg').default
      },
      tags: ['low'],
      isCompleted: false,
      isDeleted: false,
      isImportant: true
    }
  ]
}

// ------------------------------------------------
// GET: Return Tasks
// ------------------------------------------------
mock.onGet('/apps/todo/tasks').reply(config => {
  // eslint-disable-next-line object-curly-newline
  const { q = '', filter, tag, sortBy: sortByParam = 'latest' } = config.params
  /* eslint-enable */
  // ------------------------------------------------
  // Get Sort by and Sort Direction
  // ------------------------------------------------
  let sortDesc = true

  const sortBy = (() => {
    if (sortByParam === 'title-asc') {
      sortDesc = false
      return 'title'
    }
    if (sortByParam === 'title-desc') return 'title'
    if (sortByParam === 'assignee') {
      sortDesc = false
      return 'assignee'
    }
    if (sortByParam === 'due-date') {
      sortDesc = false
      return 'dueDate'
    }
    return 'id'
  })()

  // ------------------------------------------------
  // Filtering
  // ------------------------------------------------
  const queryLowered = q.toLowerCase()

  const hasFilter = task => {
    if (filter === 'important') return task.isImportant && !task.isDeleted
    if (filter === 'completed') return task.isCompleted && !task.isDeleted
    if (filter === 'deleted') return task.isDeleted
    return !task.isDeleted
  }
  /* eslint-disable */
  const filteredData = data.tasks.filter(task => {
    return task.title.toLowerCase().includes(queryLowered) && hasFilter(task) && (tag ? task.tags.includes(tag) : true)
  })
  /* eslint-enable  */

  // ------------------------------------------------
  // Perform sorting
  // ------------------------------------------------
  const sortTasks = key => (a, b) => {
    let fieldA
    let fieldB

    // If sorting is by dueDate => Convert data to date
    if (key === 'dueDate') {
      fieldA = new Date(a[key])
      fieldB = new Date(b[key])
      // eslint-disable-next-line brace-style
    }

    // If sorting is by assignee => Use `fullName` of assignee
    else if (key === 'assignee') {
      fieldA = a.assignee ? a.assignee.fullName : null
      fieldB = b.assignee ? b.assignee.fullName : null
    } else {
      fieldA = a[key]
      fieldB = b[key]
    }

    let comparison = 0

    if (fieldA === fieldB) {
      comparison = 0
    } else if (fieldA === null) {
      comparison = 1
    } else if (fieldB === null) {
      comparison = -1
    } else if (fieldA > fieldB) {
      comparison = 1
    } else if (fieldA < fieldB) {
      comparison = -1
    }

    return comparison
  }

  // Sort Data
  const sortedData = filteredData.sort(sortTasks(sortBy))
  if (sortDesc) sortedData.reverse()
  return [200, sortedData]
})

// ------------------------------------------------
// POST: Add new task
// ------------------------------------------------
mock.onPost('/apps/todo/add-tasks').reply(config => {
  // Get event from post data
  const { task } = JSON.parse(config.data)

  const { length } = data.tasks
  let lastIndex = 0
  if (length) {
    lastIndex = data.tasks[length - 1].id
  }
  task.id = lastIndex + 1

  data.tasks.push(task)

  return [201, { task }]
})

// ------------------------------------------------
// POST: Update Task
// ------------------------------------------------
mock.onPost('/apps/todo/update-task').reply(config => {
  const taskData = JSON.parse(config.data).task

  // Convert Id to number
  taskData.id = Number(taskData.id)

  const task = data.tasks.find(e => e.id === Number(taskData.id))
  Object.assign(task, taskData)

  return [200, { task }]
})

// ------------------------------------------------
// DELETE: Remove Task
// ------------------------------------------------
mock.onDelete('/apps/todo/delete-task').reply(config => {
  // Get task id from URL
  let taskId = config.taskId

  // Convert Id to number
  taskId = Number(taskId)

  const task = data.tasks.find(t => t.id === taskId)
  Object.assign(task, { isDeleted: true })
  return [200]
})
